/**
 * Normaliza descrição de despesa/compra (alinhado ao PHP `normalize_despesa_nome`).
 * - mercado (qualquer caixa) → Mercado
 * - compra | compras → Compras
 * - fornecedor | fornecedores → Fornecedor
 * - demais textos → retorna o texto trimado sem alterar capitalização
 */
export function normalizeDescricaoDespesa(raw: string): string {
  const t = raw.trim();
  if (t === "") return t;
  const lower = t.toLowerCase();
  if (lower === "mercado") return "Mercado";
  if (lower === "compra" || lower === "compras") return "Compras";
  if (lower === "fornecedor" || lower === "fornecedores") return "Fornecedor";
  return t;
}

/** Indica se o registro deve aparecer na aba Compras (Mercado/Compras/Fornecedor após normalização). */
export function isDescricaoRegistroCompras(nome: string): boolean {
  const n = normalizeDescricaoDespesa(nome);
  return n === "Mercado" || n === "Compras" || n === "Fornecedor";
}

/**
 * Detecta se o texto é exclusivamente Mercado, Compras ou Fornecedor (variações de caixa).
 * Se não for, a edição na aba Compras deve salvar como despesa comum (`normalizeDescricaoDespesa`).
 */
export function resolveDescricaoSomenteCompras(raw: string): "Mercado" | "Compras" | "Fornecedor" | null {
  const t = raw.trim();
  if (t === "") return null;
  const lower = t.toLowerCase();
  if (lower === "mercado") return "Mercado";
  if (lower === "compra" || lower === "compras") return "Compras";
  if (lower === "fornecedor" || lower === "fornecedores") return "Fornecedor";
  return null;
}
